import React from 'react';
import PropTypes from 'prop-types';
import { FormattedMessage } from 'react-intl';
import { Typography } from '@material-ui/core';
import ExpansionSection from 'components/templates/ExpansionSection';
import useFileLightbox from '../hooks/useFileLightbox';
import FileRow from './FileRow';

const FileGroupAccordion = ({
  cottageId,
  cottageName,
  label,
  count,
  maxCount,
  files,
  cottages,
  counts,
  isUpdating,
  onView,
  onDownload,
  onRename,
  onReassign,
  onDelete,
  defaultExpanded,
}) => {
  const { handleView, lightboxElement } = useFileLightbox({
    files,
    onView,
    onDownload,
    subtitle: cottageName,
  });

  const summary = (
    <span>
      <span style={{ display: 'block' }}>{label}</span>
      <Typography variant="body2" color="textSecondary" component="span">
        <FormattedMessage
          id="hostFiles.fileCount"
          defaultMessage="{count} / {max} files"
          values={{ count, max: maxCount }}
        />
      </Typography>
    </span>
  );

  return (
    <ExpansionSection summary={summary} defaultExpanded={defaultExpanded}>
      <div style={{ width: '100%' }}>
        {files.length === 0 ? (
          <>
            <Typography variant="body2" color="textSecondary">
              <FormattedMessage
                id="hostFiles.groupEmptyTitle"
                defaultMessage="No file linked to this listing yet."
              />
            </Typography>
            <Typography variant="body2" color="textSecondary">
              <FormattedMessage
                id="hostFiles.groupEmptyHelper"
                defaultMessage="Upload a file and link it here."
              />
            </Typography>
          </>
        ) : (
          files.map((file) => (
            <FileRow
              key={file.id}
              file={file}
              cottageId={cottageId}
              cottages={cottages}
              counts={counts}
              maxCount={maxCount}
              isUpdating={isUpdating}
              onView={handleView}
              onDownload={onDownload}
              onRename={onRename}
              onReassign={onReassign}
              onDelete={onDelete}
            />
          ))
        )}
        {lightboxElement}
      </div>
    </ExpansionSection>
  );
};

FileGroupAccordion.propTypes = {
  cottageId: PropTypes.number.isRequired,
  cottageName: PropTypes.string,
  label: PropTypes.node.isRequired,
  count: PropTypes.number.isRequired,
  maxCount: PropTypes.number.isRequired,
  files: PropTypes.arrayOf(PropTypes.shape({})).isRequired,
  cottages: PropTypes.arrayOf(PropTypes.shape({})).isRequired,
  counts: PropTypes.shape({}),
  isUpdating: PropTypes.bool,
  onView: PropTypes.func.isRequired,
  onDownload: PropTypes.func.isRequired,
  onRename: PropTypes.func.isRequired,
  onReassign: PropTypes.func.isRequired,
  onDelete: PropTypes.func.isRequired,
  defaultExpanded: PropTypes.bool,
};

export default FileGroupAccordion;
